import api from '@/api'
// get activiation
export default {
  getAllCampaignsNoStatus() {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/campaigns/all?limit=999', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getSpeedData(type, filters) {
    return new Promise(function (resolve, reject) {
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      api
        .request('get', `/api/v1/campaigns/speed/${type}/duration?limit=999&${params}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/views/DashboardComponents/SpeedHelper.js